import React from 'react';

// One-line archive-label art: 1.5 stroke, square caps, no fills.
// Decorative in every use here — each icon sits beside a real text label,
// so they are all aria-hidden and never carry meaning on their own.
const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'square',
  strokeLinejoin: 'miter',
  'aria-hidden': 'true',
  focusable: 'false',
};

export const IconWall = p => (
  <svg {...base} {...p}>
    <rect x="3" y="4" width="18" height="7" />
    <rect x="3" y="13" width="18" height="7" />
    <path d="M10 4v7M14 13v7" />
  </svg>
);

export const IconTag = p => (
  <svg {...base} {...p}>
    <path d="M3 11V3h8l10 10-8 8z" />
    <path d="M7.5 7.5h.01" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

export const IconKey = p => (
  <svg {...base} {...p}>
    <circle cx="8" cy="8" r="4.5" />
    <path d="M11.5 11.5 20 20M17 17l-2 2M20 14l-2 2" />
  </svg>
);

export const IconOut = p => (
  <svg {...base} {...p}>
    <path d="M10 4H4v16h6M14 8l4 4-4 4M18 12H9" />
  </svg>
);

export const IconPlus = p => (
  <svg {...base} {...p}><path d="M12 5v14M5 12h14" /></svg>
);

export const IconCheck = p => (
  <svg {...base} {...p}><path d="m4 12 5 5L20 6" /></svg>
);

export const IconX = p => (
  <svg {...base} {...p}><path d="M5 5l14 14M19 5L5 19" /></svg>
);

export const IconPencil = p => (
  <svg {...base} {...p}><path d="M4 20h4L20 8l-4-4L4 16z" /></svg>
);

export const IconTrash = p => (
  <svg {...base} {...p}>
    <path d="M4 6h16M9 6V3h6v3M6 6l1 15h10l1-15" />
  </svg>
);

export const IconArrow = p => (
  <svg {...base} {...p}><path d="M4 12h15M14 7l5 5-5 5" /></svg>
);

export const IconAlert = p => (
  <svg {...base} {...p}>
    <path d="M12 3 1.5 21h21z" />
    <path d="M12 10v4" />
    <path d="M12 17.5h.01" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

export const IconStamp = p => (
  <svg {...base} {...p}>
    <path d="M5 20h14M7 17h10l-1-5h-2.2c.4-2 .7-3.4.7-4.5A2.5 2.5 0 0 0 12 5a2.5 2.5 0 0 0-2.5 2.5c0 1.1.3 2.5.7 4.5H8z" />
  </svg>
);
